import { http } from "@/utils/http";

export const accountLogin = data => {
  return http.request("post", "/biz/account/auth/login", { data });
};

export const accountLogout = data => {
  return http.request("post", "/biz/account/auth/logout", {
    data
  });
};
